export const GET_USER_INFO = "GET_USER_INFO";
export const LOGIN = " LOGIN";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const CHECK_OTP = "CHECK_OTP";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const GET_CONFIG = "GET_CONFIG";
export const GET_DOMAIN = "GET_DOMAIN";
export const REGISTER_TOKEN = "REGISTER_TOKEN";
export const ID_DOMAIN = "ID_DOMAIN";
export const MERCURE_DATA = "MERCURE_DATA";
export const UPDATE_BUSINESS_INFO = "UPDATE_BUSINESS_INFO";
export const GET_USER_SIGNIN_INFO = "GET_USER_SIGNIN_INFO";
